// VITE NEW IMPORT

export const filterTypeDictionary = {
  normalFilter: "normal-filter",
  radioFilter: "radio-filter",
  localizeFilter: "localization-filter",
  sliderFilter: "slider-filter",
  proximityFilter: "proximity-filter",
  hsCodeFilter: "hsCode-filter",
  boxFilter: "box-filter",
  rangeFilter: "range-filter",
  weightFilter: "weight-filter",
};

//Below are the backend key mapped with label we have to show on UI
export const filterLabel = {
  tagList: "Tag list",
  contacts: "Contacts",
  type: "Type",
  dataSource: "Data source",
  "download type": "Download Type",
  dataset: "Dataset",
};
